export function paddingZero(str) {
  return ('00' + str).substr(str.length);
}

export function dateStrChangeTimeTamp(dateStr) {
  dateStr = dateStr.substring(0, 19);
  dateStr = dateStr.replace(/-/g, '/');
  return new Date(dateStr).getTime();
}
//获取指定时区时间
export const getNowDate = timeZone => {
  var timezone = timeZone || 8; //目标时区时间，东八区
  // 本地时间和格林威治的时间差，单位为分钟
  var offset_GMT = new Date().getTimezoneOffset();
  // 本地时间距 1970 年 1 月 1 日午夜（GMT 时间）之间的毫秒数
  var nowDate = new Date().getTime();
  var targetDate = nowDate + offset_GMT * 60 * 1000 + timezone * 60 * 60 * 1000;
  return targetDate;
};

/**
 * 获取当前时区相对 UTC 的偏移量（小时）
 * @returns {number}
 */
export function getCurrentTimeZoneOffset() {
  // 获取当前时区相对 UTC 的偏移量（分钟）
  const offsetMinutes = new Date().getTimezoneOffset();
  return -offsetMinutes / 60; // 将分钟转换为小时，并考虑符号的关系
}

/**
 * 将日期字符串从源时区转换为目标时区
 * @param dateStr
 * @param fromTimeZoneOffset
 * @param toTimeZoneOffset
 * @returns {Date}
 */
export function convertTimeZone(dateStr, fromTimeZoneOffset, toTimeZoneOffset) {
  // 将输入的时间字符串转换成Date对象
  const date = new Date(dateStr);

  // 计算输入时间的UTC时间
  const utcTime = date.getTime() - fromTimeZoneOffset * 60 * 60 * 1000;

  return new Date(utcTime + toTimeZoneOffset * 60 * 60 * 1000); // 计算目标时区的时间
}

/**
 * 将日期对象格式化为字符串 yyyy-MM-dd HH:mm:ss
 * @param date
 * @returns {string}
 */
export function formatDate_yyyyMMddHHmmss(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从0开始，所以要加1
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

/**
 * 格式化秒为："HH:mm:ss"，<1小时格式化为："mm:ss"
 * @param {Number} dur 秒或毫秒数
 * @param {Boolean} isMillisecond 是否是毫秒，默认false
 * @returns
 */
export function formatDuration(dur, isMillisecond = false) {
  if (!isNaN(dur) && dur >= 0) {
    const dura = dayjs.duration(isMillisecond ? dur : dur * 1000);
    // 获取总小时数、分钟和秒数
    const hours = Math.floor(dura.asHours()); // 获取总小时数
    const minutes = dura.minutes(); // 计算不足1小时的分钟
    const seconds = dura.seconds(); // 计算不足1分钟的秒
    if (hours > 0) {
      // 格式化为字符串 "HH:mm:ss"
      return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(
        seconds
      ).padStart(2, '0')}`;
    } else {
      // 格式化为字符串 "mm:ss"
      return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
    }
  }
  return '--:--';
}
